// @flow
// datepicker
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
//import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/cs';
import 'flatpickr/dist/l10n/sk';

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'AddSvgIconSprite':
			return import('./components/AddSvgIconSprite');
		case 'WebLayout':
			return import('./components/WebLayout');
		case 'RadioSelect':
			// COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
			return import('fg-frontend/src/components/RadioSelect');
		case 'CheckboxSelect':
			// COMMON: Komponenta pro podporu hromadneho zaskrtnuti ve skupine checkboxu (odeberte pokud nepouzivate ve vypisech produktu komponenty pro checkboxovou filtraci tagFilter, brandFilter, parameterFilter)
			return import('fg-frontend/src/components/CheckboxSelect');
		case 'SimpleCollapse':
			return import('fg-frontend/components/SimpleCollapse');
		case 'SizeGuide':
			return import('./components/SizeGuide');
		case 'SubmenuToggle':
			return import('./components/SubmenuToggle');
		case 'GalleryWebslider':
			return import('./components/GalleryWebslider');
		case 'Typeahead':
			// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
			return import('fg-frontend/components/Typeahead');
		case 'SelectDesign':
			// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
			return import('./components/SelectDesign');
		case 'ListToggle':
			// COMMON: Komponenta pro skryti/zobrazeni casti seznamu (odeberte pokud nepouzivate Nejprodavanejsi produkty ve vypisu produktu, ani vypis parametru v detailu produktu, ani nemate v projektu nakupni proces)
			return import('fg-frontend/components/ListToggle');
		case 'PasswordToggle':
			// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
			return import('fg-frontend/components/PasswordToggle');
		case 'SocialShare':
			// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
			return import('fg-frontend/src/components/SocialShare');
		case 'AnchorsList':
			// COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
			return import('fg-frontend/src/components/AnchorsList');
		case 'Slider':
			// COMMON: Intervalovy slider v1 bez podpory histogramu (odeberte, pokud nepouzivate ve vypisech produktu komponenty pro filtraci pomoci intervalu, napr. ceny, nebo pokud je pouzita komponeta RangeSlider)
			return import('fg-frontend/components/Slider');
		case 'RadioSelectTab':
			// COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
			return import('fg-frontend/src/components/RadioSelectTab');
		case 'NumberInput':
			// COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
			return import('fg-frontend/components/NumberInput');
		case 'UniversalPaginationButton':
			// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
			return import('fg-frontend/components/UniversalPaginationButton');
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'GtmHandler':
			return import('./components/GtmHandler');
		case 'TriggerInViewport':
			return import('./components/TriggerInViewport');
		case 'ShareUrl':
			// COMMON: Komponenta, ktera zkopiruje danou URL, resp. string do schranky (odeberte, pokud nepouzivate funkci Ziskat odkaz v detailu produktu ani Sdileni kosiku)
			return import('fg-frontend/src/components/ShareUrl');
		case 'PhotoSwipe':
			return import('./components/PhotoSwipe');
		case 'RedirectToUrl':
			// COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
			return import('fg-frontend/src/components/RedirectToUrl');
		case 'Form':
			// COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
			return import('fg-frontend/src/components/Form');
		case 'LazyImage':
			return import('./components/LazyImage');
		case 'Webslider':
			return import('fg-frontend/src/components/Webslider');
		case 'PrintPage':
			// COMMON: Komponenta, ktera vytiskne libovolnou stranku z webu dle jeji URL (odeberte, pokud nepouzivate B2B objednavky, ani sdileni kosiku)
			return import('fg-frontend/src/components/PrintPage');
		case 'PrintPdf':
			// COMMON: Komponenta, ktera zajistuje tisk PDF (odeberte, pokud nepouzivate Faktury)
			return import('fg-frontend/src/components/PrintPdf');
		case 'FileInput':
			// COMMON: Komponenta pro vlozeni jedineho souboru (odeberte, pokud nepouzivate Import objednavky z CVS)
			return import('fg-frontend/src/components/FileInput');
		case 'GoogleMap':
			// COMMON: Google Mapa
			return import('./components/GoogleMap');
		case 'GoogleRecaptcha':
			// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
			return import('fg-frontend/src/components/GoogleRecaptcha');
		case 'Datepicker':
			return Datepicker;
    case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      return import('./components/FGUpload');
    case 'PreventDoubleClickHandler':
      // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
    case 'FaqCollapse':
      return import('./components/FaqCollapse');
    case 'ImageProjector':
      return import('./components/ImageProjector');
    case 'PhotoGallery':
      return import('./components/PhotoGallery');
    default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			} else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js